import * as actionTypes from './actionTypes';
import { typePublicationService } from './services';
import { actionsModalError } from '@app/src/common/modalError';

const fetchTypeOperationRequest = () => ({
  type: actionTypes.FETCH_TYPE_PUBLICATION_REQUEST
});

const fetchTypeOperationSuccess = (data) => ({
  type: actionTypes.FETCH_TYPE_PUBLICATION_SUCCESS,
  data
});

const fetchTypeOperationFailure = () => ({
  type: actionTypes.FETCH_TYPE_PUBLICATION_FAILURE
});

export const fetchTypePublication = (idCategory:number, idOperation?: number, idOwnInput?: number): Function => {
  return async dispatch => {
    dispatch(fetchTypeOperationRequest());
    try {
      const data = await typePublicationService.get(idCategory, idOperation, idOwnInput);
      dispatch(fetchTypeOperationSuccess(data));
    } catch(e) {
      dispatch(fetchTypeOperationFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};
